import React from 'react'
import { useSelector } from 'react-redux'
import { text } from '@groovehq/internal-design-system/lib/styles/elements'
import { selectReportingPermitted } from 'ducks/currentUser/selectors/selectReportingPermitted'
import { SETTINGS_BILLING_PAGE } from 'subapps/settings/types'
import { LANDING_PAGE as KB_LANDING_PAGE } from 'subapps/kb/pages'
import { selectIsFreemium } from 'ducks/billing/selectors/selectIsFreemium'
import { selectCurrentUserIsAdminOrOwner } from 'ducks/currentUser/selectors'
import CentralizeSection from './CentralizeSection'
import AnalyzeSection from './AnalyzeSection'
import IntegrationsSection from './IntegrationsSection'
import Item from './Item'
import { styles } from './styles'

const toKbLandingPage = { type: KB_LANDING_PAGE }
export const toBillingPage = { type: SETTINGS_BILLING_PAGE }

const Nav = ({ className, active }) => {
  const showReporting = useSelector(selectReportingPermitted)
  const showUpgrade = useSelector(
    state =>
      selectIsFreemium(state, 'inbox') && selectCurrentUserIsAdminOrOwner(state)
  )

  return (
    <nav className={className}>
      <div
        css={[text.styles.fontMedium, styles.list]}
        className="grui flex items-center"
      >
        <CentralizeSection css={styles.item} active={active} />
        {showReporting && <AnalyzeSection css={styles.item} active={active} />}

        <Item
          to={toKbLandingPage}
          css={styles.item}
          isActive={active === 'Knowledge Base'}
        >
          Knowledge Base
        </Item>

        <IntegrationsSection css={styles.item} />

        {showUpgrade && (
          <Item css={styles.upgrade} to={toBillingPage}>
            Upgrade your free plan
          </Item>
        )}
      </div>
    </nav>
  )
}

export default Nav
